module.exports = __webpack_public_path__ + "img/check-circle-fill@3x.a59a093f.png";